import { Component, Input, OnInit, OnChanges } from '@angular/core';
import {
  AUDIENCE_TYPE,
  AudienceExternal,
  AudienceReport,
  isAudienceSegment,
  isAudienceStatic,
  isSegmentWithAudienceExternal,
  Segment,
} from 'emma-common-ts/emma';

@Component({
    selector: 'emma-audience-type-info',
    templateUrl: './emma-audience-type-info.component.html',
    standalone: false
})
export class EMMAAudienceTypeInfoComponent implements OnInit, OnChanges {
  @Input() audience!: AudienceReport;
  @Input() audiencesExternal?: AudienceExternal[];
  @Input() color = '';
  hasAudienceExternal = false;
  isStatic = false;
  private isSegmentWithAudienceExternal?: (segment: Segment) => boolean;
  AUDIENCE_TYPE = AUDIENCE_TYPE;
  alertClass: string[] = [];

  ngOnInit(): void {
    this.alertClass = [
      'm-alert m-alert--outline m-alert--icon m-alert--square alert m--margin-top-20',
      this.color ? `alert-${this.color}` : 'alert-emmadarkblue',
    ];
  }

  ngOnChanges(): void {
    this.isStatic = this.audience && isAudienceStatic(this.audience);
    if (this.audiencesExternal?.length) {
      this.isSegmentWithAudienceExternal = isSegmentWithAudienceExternal(this.audiencesExternal);
    }
    if (this.audience && isAudienceSegment(this.audience) && this.isSegmentWithAudienceExternal) {
      this.hasAudienceExternal = this.isSegmentWithAudienceExternal(this.audience.segment);
    } else {
      this.hasAudienceExternal = false;
    }
  }
}
